import { render, staticRenderFns } from "./ModalMyAccountMenuCustom.vue?vue&type=template&id=5e535748"
import script from "./ModalMyAccountMenuCustom.vue?vue&type=script&lang=js"
export * from "./ModalMyAccountMenuCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports